"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._purge = exports._setObject = exports.set = exports.get = exports.setServerHook = exports.serverHook = exports.available = void 0;
const storageName = 'sk-pref';
let storage;
let serverStorage;
if (typeof window === 'undefined') {
    storage = {};
    serverStorage = {};
}
else {
    const json = window.localStorage.getItem(storageName);
    storage = (json && JSON.parse(json)) || {};
    const serverJson = window.localStorage.getItem(`${storageName}-server`);
    serverStorage = (serverJson && JSON.parse(serverJson)) || {};
}
exports.available = !!Object.keys(storage).length;
function setServerHook(hook) {
    if (exports.serverHook) {
        throw new Error('Server hook already defined');
    }
    exports.serverHook = hook;
}
exports.setServerHook = setServerHook;
/**
 * Get some data from the storage.
 *
 * @param {string} key The key the data is stored under.
 * @param {*} defaultValue The value to return if the data isn't found.
 * @returns {*} Stored data, or defaultValue if data doesn't exist.
 */
function get(key, defaultValue) {
    if (!storage) {
        return undefined;
    }
    return storage[key] === undefined
        ? defaultValue
        : JSON.parse(JSON.stringify(storage[key]));
}
exports.get = get;
let setPersistTimeout;
/**
 * Set some data in the storage.
 *
 * @param {string} key The key to store the data under.
 * @param {*} value The data to store.
 * @param {boolean=false} persist If true, data will persist to other sessions.
 * @param {boolean=false} bufferPersist If true, will wait until next tick
 *                                      before sending persist request.
 * @returns {Promise} Promise which resolves when preferences are set.
 */
function set(key, value, persist = false, bufferPersist = false) {
    const prefChanged = JSON.stringify(get(key)) !== JSON.stringify(value);
    // Safari private browsing mode throws an error :(
    try {
        if (typeof value === 'object') {
            storage[key] = JSON.parse(JSON.stringify(value));
        }
        else {
            storage[key] = value;
        }
        window.localStorage.setItem(storageName, JSON.stringify(storage));
        if (!prefChanged) {
            return Promise.resolve();
        }
        const shouldPersist = persist && !get('staff-warning') && !!exports.serverHook;
        if (shouldPersist) {
            serverStorage[key] = value;
            window.localStorage.setItem(`${storageName}-server`, JSON.stringify(serverStorage));
            if (bufferPersist) {
                // Note that actually using this as a promise might cause it to not
                // work if you're setting the next thing when it resolves - it will
                // have already sent the request. Best to just not use this promise.
                return new Promise((resolve, reject) => {
                    clearTimeout(setPersistTimeout);
                    setPersistTimeout = setTimeout(() => {
                        (0, exports.serverHook)(serverStorage).then(resolve, reject);
                    });
                });
            }
            else {
                return (0, exports.serverHook)(serverStorage);
            }
        }
        return Promise.resolve();
    }
    catch (e) {
        return Promise.reject(e);
    }
}
exports.set = set;
/**
 * Function for mass setting data after login. Probably don't use it. If you
 * want to set more than one property at once without making multiple requests
 * to the server, look at the `bufferPersist` property of the set function.
 *
 * @private
 * @param {object} object The object to set.
 * @returns {boolean} True if it worked
 */
function _setObject(object) {
    try {
        Object.assign(storage, object);
        Object.assign(serverStorage, object);
        window.localStorage.setItem(storageName, JSON.stringify(storage));
        window.localStorage.setItem(`${storageName}-server`, JSON.stringify(serverStorage));
        return true;
    }
    catch (e) {
        return false;
    }
}
exports._setObject = _setObject;
/**
 * Purge the data from local storage. Don't use this to log out, use the
 * deauthenticate method of the auth service instead.
 *
 * @private
 * @returns {boolean} true if successful
 */
function _purge() {
    try {
        storage = {};
        serverStorage = {};
        window.localStorage.removeItem(storageName);
        window.localStorage.removeItem(`${storageName}-server`);
        return true;
    }
    catch (e) {
        return false;
    }
}
exports._purge = _purge;
//# sourceMappingURL=pref-storage.js.map